import { ErrorBoundary } from '@sentry/react'

const ErrorBoundarySignup = (props) => {
    return (
        <ErrorBoundary
            fallback={
                <h1>
                    Couldn't load sign up view. Something went wrong. Check
                    Sentry for logs
                </h1>
            }
        >
            {props.children}
        </ErrorBoundary>
    )
}

export default ErrorBoundarySignup
